import NodeFetchResponse from './response.node';
export default function fetchNode(url, options) {
  return new NodeFetchResponse(url, options);
}
//# sourceMappingURL=fetch.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/fetch-node/fetch.node.js
// module id = 773
// module chunks = 0